<!-- @format -->
<ng-container *transloco="let t">
  <sis-study-notification-box
    [useFudisLink]="true"
    type="info"
    [tertiaryButtonText]="'PLAN.SHOW_ATTAINMENT_DETAILS'"
    (tertiaryClickAction)="openAttainmentDetailsModal()">
  </sis-study-notification-box>
</ng-container>
